import {Routes} from '@angular/router';
import {headerTitle} from '@shared/utils';
import {ZbAuthCheckerService, UserLevelEnum} from '@zibanu/auth';
import {SETTING_ROUTE_LIST} from './settings.routes';
import {ValidRolesByRouteGuard} from '@auth/guards/valid-roles-by-route.guard';
import {IsAuthenticatedGuard} from '@auth/guards/is-authenticated.guard';
import {ValidHomeSafeGuard} from '@auth/guards/valid-home-safe.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./modules/main/container/main-container'),
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        title: headerTitle(),
        path: 'home',
        loadComponent: () => import('./modules/home/container/home-container'),
        canActivate: [ValidHomeSafeGuard],
      },
      {
        path: 'overview',
        loadComponent: () => import('./modules/overview/container/overview-container'),
        canActivate: [IsAuthenticatedGuard],
      },
      {
        title: headerTitle('Settings'),
        path: 'settings',
        data: {role: UserLevelEnum.Operator},
        children: [...SETTING_ROUTE_LIST],
        canActivate: [IsAuthenticatedGuard],
        canActivateChild: [ValidRolesByRouteGuard],
        providers: [ZbAuthCheckerService],
      },
    ]
  },
  {
    path: 'partners',
    loadComponent: () => import('./auth/components/login'),
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];
